// @flow
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {AppBanner} from '@homeaway/react-app-banner';
import {EdapProvider} from '@homeaway/react-event-tracking';
import type {State as ReduxState} from '../../reducers/index';
type StateProps = {
    fullLocale: string,
    isAndroid: boolean,
    isMobile: boolean,
    siteName: string,
    travelerApp: string
};

type Props = StateProps;

const AppDownloadBanner = ({
    fullLocale,
    isAndroid,
    isMobile,
    siteName,
    travelerApp
}: Props) => {
    const mobileOS = isAndroid ? 'android' : 'ios';
    return (
        <EdapProvider>
            <AppBanner
                isMobile={isMobile}
                locale={fullLocale}
                mobileOS={mobileOS}
                page="serp"
                showBanner
                siteName={siteName}
                travelerApp={travelerApp}
                useCanonicalPath
            />
        </EdapProvider>
    );
};

const mapStateToProps = ({
    system: {fullLocale, isAndroid, isMobile, siteName, travelerApp}
}: ReduxState): StateProps => ({
    fullLocale,
    isAndroid,
    isMobile,
    siteName,
    travelerApp
});
export default compose(connect(mapStateToProps))(AppDownloadBanner);
